const { render, useState } = wp.element;
import { createRoot } from 'react-dom/client';
import { StrictMode } from 'react';

import { Provider } from 'react-redux';
import { legacy_createStore as createStore, applyMiddleware } from 'redux';
import { thunk } from 'redux-thunk';

//Model Values reducers
import frontreducer from './reducer/front_reducer';

//Language Files
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import * as Constants from './constants';
import Cookies from 'js-cookie';
//Files to show up
import Showcontestants from './react-frontend/Showcontestants.jsx';
import Showallcontestants from './react-frontend/Showallcontestants.jsx';

import Addcontestants from './react-frontend/Addcontestants.jsx';
import Addcontest from './react-frontend/Addcontest.jsx';
import Logincontest from './react-frontend/Logincontest.jsx';

import Singlecontestants from './react-frontend/Singlecontestants.jsx';
import Singlepagesplit from './react-frontend/Singlepagesplit.jsx';
import Leaderwidgets from './react-frontend/Leaderwidgets.jsx';

import Profile from './react-frontend/Profile.jsx';
import Showallcategories from './react-frontend/Showallcategories.jsx';

import { createTheme, ThemeProvider } from '@mui/material/styles';
import { pink } from '@mui/material/colors';

const votingtheme = createTheme({
  props: { MuiButtonBase: { disableRipple: true, } },
  palette: {
    secondary: pink,
  },
});


const search_val = document.querySelectorAll("[id^='wpvc-root-shortcode']");
let pages = '';
let site_url = '';
let check_page = Array();
if (search_val.length > 0) {
  search_val.forEach(function (item, index) {
    pages = item.getAttribute('data-rootcode');
    site_url = item.getAttribute('data-url');
    if (!check_page.includes(pages)) {
      check_page.push(pages);
      render_page_shortcodes(pages, site_url);
    }
  });
}

//Twitter Signin
if (window.opener) {
  const [, oauthToken, oauthVerifier] =
    window.location.search.match(
      /^(?=.*oauth_token=([^&]+)|)(?=.*oauth_verifier=([^&]+)|).+$/
    ) || [];
  if (oauthToken) {
    window.opener.postMessage(
      {
        type: "authorized",
        data: {
          oauthToken,
          oauthVerifier
        }
      },
      window.origin
    );
    window.close();
  }
}



function render_page_shortcodes(page, site_url) {
  //For switch case
  let render_comp = '';
  let div_to_render = '';
  let div_app = '';
  let siteurl = '';
  let originalurl = '';
  let shortarg = '';
  let get_store = '';
  let div_to_header = '';
  let div_to_footer = '';
  let div_header_app = '';
  let div_footer_app = '';
  setTranslation(site_url);
  //Store
  if (page != 'showcontestants' && page != 'addcontestants') {
    get_store = createStore(frontreducer, applyMiddleware(thunk));
  }

  switch (page) {
    case 'showcontestants':
      let div_getid = document.querySelectorAll("[id^='wpvc-showcontestants-page-']");
      if (div_getid.length > 0) {
        div_getid.forEach(function (item, index) {
          div_to_render = item.id;
          const div_app = document.getElementById(div_to_render);
          siteurl = div_app.getAttribute('data-url');
          originalurl = div_app.getAttribute('data-originalurl');
          get_store = createStore(frontreducer, applyMiddleware(thunk));
          shortarg = JSON.parse(div_app.getAttribute('data-args'));
          const render_comp = <ThemeProvider theme={votingtheme}><Provider store={get_store}><I18nextProvider i18n={i18n}><Showcontestants shortagrument={shortarg} CONSTANT={Constants} SITE_URL={siteurl} ORIGINAL_URL={originalurl} /></I18nextProvider></Provider></ThemeProvider>;
          // render(render_comp, div_app);
          const root = createRoot(div_app);
          // root.render(<StrictMode>{render_comp}</StrictMode>);
          root.render(render_comp);
          return;
        });
      }
      break;

    case 'showallcontestants':
      div_to_render = 'wpvc-showallcontest-page';
      div_app = document.getElementById(div_to_render);
      siteurl = div_app.getAttribute('data-url');
      originalurl = div_app.getAttribute('data-originalurl');
      shortarg = JSON.parse(div_app.getAttribute('data-args'));
      if (shortarg.design == "new") {
        render_comp = <ThemeProvider theme={votingtheme}><Provider store={get_store}><I18nextProvider i18n={i18n}><Showallcategories shortagrument={shortarg} CONSTANT={Constants} SITE_URL={siteurl} ORIGINAL_URL={originalurl} /></I18nextProvider></Provider></ThemeProvider>;
      } else {
        render_comp = <ThemeProvider theme={votingtheme}><Provider store={get_store}><I18nextProvider i18n={i18n}><Showallcontestants shortagrument={shortarg} CONSTANT={Constants} SITE_URL={siteurl} ORIGINAL_URL={originalurl} /></I18nextProvider></Provider></ThemeProvider>;
      }
      break;

    case 'addcontestants':
      let div_getaddid = document.querySelectorAll("[id^='wpvc-addcontestant-page-']");
      if (div_getaddid.length > 0) {
        div_getaddid.forEach(function (item, index) {
          div_to_render = item.id;
          const div_app = document.getElementById(div_to_render);
          siteurl = div_app.getAttribute('data-url');
          originalurl = div_app.getAttribute('data-originalurl');
          get_store = createStore(frontreducer, applyMiddleware(thunk));
          shortarg = JSON.parse(div_app.getAttribute('data-args'));
          const render_comp = <ThemeProvider theme={votingtheme}><Provider store={get_store}><I18nextProvider i18n={i18n}><Addcontestants shortagrument={shortarg} CONSTANT={Constants} SITE_URL={siteurl} ORIGINAL_URL={originalurl} /></I18nextProvider></Provider></ThemeProvider>;
          // render(render_comp, div_app);
          const root = createRoot(div_app);
          root.render(<StrictMode>{render_comp}</StrictMode>);
          return;
        });
      }
      break;

    case 'addcontest':
      div_to_render = 'wpvc-addcontest-page';
      div_app = document.getElementById(div_to_render);
      siteurl = div_app.getAttribute('data-url');
      originalurl = div_app.getAttribute('data-originalurl');
      shortarg = JSON.parse(div_app.getAttribute('data-args'));
      render_comp = <ThemeProvider theme={votingtheme}><Provider store={get_store}><I18nextProvider i18n={i18n}><Addcontest shortagrument={shortarg} CONSTANT={Constants} SITE_URL={siteurl} ORIGINAL_URL={originalurl} /></I18nextProvider></Provider></ThemeProvider>;
      break;

    case 'upcomingcontestants':
      div_to_render = 'wpvc-upcomingcontestants-page';
      div_app = document.getElementById(div_to_render);
      siteurl = div_app.getAttribute('data-url');
      originalurl = div_app.getAttribute('data-originalurl');
      shortarg = JSON.parse(div_app.getAttribute('data-args'));
      render_comp = <ThemeProvider theme={votingtheme}><Provider store={get_store}><I18nextProvider i18n={i18n}><Showcontestants shortagrument={shortarg} CONSTANT={Constants} SITE_URL={siteurl} ORIGINAL_URL={originalurl} /></I18nextProvider></Provider></ThemeProvider>;
      break;

    case 'endcontestants':
      div_to_render = 'wpvc-endcontestants-page';
      div_app = document.getElementById(div_to_render);
      siteurl = div_app.getAttribute('data-url');
      originalurl = div_app.getAttribute('data-originalurl');
      shortarg = JSON.parse(div_app.getAttribute('data-args'));
      render_comp = <ThemeProvider theme={votingtheme}><Provider store={get_store}><I18nextProvider i18n={i18n}><Showcontestants shortagrument={shortarg} CONSTANT={Constants} SITE_URL={siteurl} ORIGINAL_URL={originalurl} /></I18nextProvider></Provider></ThemeProvider>;
      break;

    case 'profilecontestants':
      div_to_render = 'wpvc-profilecontestants-page';
      div_app = document.getElementById(div_to_render);
      siteurl = div_app.getAttribute('data-url');
      originalurl = div_app.getAttribute('data-originalurl');
      shortarg = JSON.parse(div_app.getAttribute('data-args'));
      render_comp = <ThemeProvider theme={votingtheme}><Provider store={get_store}><I18nextProvider i18n={i18n}><Profile shortagrument={shortarg} CONSTANT={Constants} SITE_URL={siteurl} ORIGINAL_URL={originalurl} /></I18nextProvider></Provider></ThemeProvider>;
      break;

    case 'topcontestants':
      div_to_render = 'wpvc-topcontestants-page';
      div_app = document.getElementById(div_to_render);
      siteurl = div_app.getAttribute('data-url');
      originalurl = div_app.getAttribute('data-originalurl');
      shortarg = JSON.parse(div_app.getAttribute('data-args'));
      render_comp = <ThemeProvider theme={votingtheme}><Provider store={get_store}><I18nextProvider i18n={i18n}><Showcontestants shortagrument={shortarg} CONSTANT={Constants} SITE_URL={siteurl} ORIGINAL_URL={originalurl} /></I18nextProvider></Provider></ThemeProvider>;
      break;

    case 'logincontest':
      div_to_render = 'wpvc-logincontest-page';
      div_app = document.getElementById(div_to_render);
      siteurl = div_app.getAttribute('data-url');
      originalurl = div_app.getAttribute('data-originalurl');
      shortarg = JSON.parse(div_app.getAttribute('data-args'));
      render_comp = <ThemeProvider theme={votingtheme}><Provider store={get_store}><I18nextProvider i18n={i18n}><Logincontest short={shortarg} CONSTANT={Constants} SITE_URL={siteurl} ORIGINAL_URL={originalurl} /></I18nextProvider></Provider></ThemeProvider>;
      break;

    case 'singlecontestants':
      div_to_render = 'wpvc-singlecontestant-page';
      div_app = document.getElementById(div_to_render);
      siteurl = div_app.getAttribute('data-url');
      originalurl = div_app.getAttribute('data-originalurl');
      let post_id = div_app.getAttribute('data-postid');
      shortarg = JSON.parse(div_app.getAttribute('data-args'));
      render_comp = <ThemeProvider theme={votingtheme}><Provider store={get_store}><I18nextProvider i18n={i18n}><Singlecontestants shortagrument={shortarg} CONSTANT={Constants} SITE_URL={siteurl} ORIGINAL_URL={originalurl} SINGLEPOST={post_id} /></I18nextProvider></Provider></ThemeProvider>;
      break;

    case 'singlepagesplit':
      div_to_header = 'wpvc-singlecustom-header';
      div_to_footer = 'wpvc-singlecustom-footer';
      div_header_app = document.getElementById(div_to_header);
      div_footer_app = document.getElementById(div_to_footer);
      div_app = '';

      siteurl = div_header_app.getAttribute('data-url');
      originalurl = div_header_app.getAttribute('data-originalurl');
      let spost_id = div_header_app.getAttribute('data-postid');
      shortarg = JSON.parse(div_header_app.getAttribute('data-args'));

      render_comp = <ThemeProvider theme={votingtheme}><Provider store={get_store}><I18nextProvider i18n={i18n}><Singlepagesplit templatepart="header" shortagrument={shortarg} CONSTANT={Constants} SITE_URL={siteurl} ORIGINAL_URL={originalurl} SINGLEPOST={spost_id} /></I18nextProvider></Provider></ThemeProvider>;
      // render(render_comp, div_header_app);
      const root1 = createRoot(div_header_app);
      root1.render(<StrictMode>{render_comp}</StrictMode>);

      let render_component = <ThemeProvider theme={votingtheme}><Provider store={get_store}><I18nextProvider i18n={i18n}><Singlepagesplit templatepart="footer" shortagrument={shortarg} CONSTANT={Constants} SITE_URL={siteurl} ORIGINAL_URL={originalurl} SINGLEPOST={spost_id} /></I18nextProvider></Provider></ThemeProvider>;
      // render(render_component, div_footer_app);
      const root2 = createRoot(div_footer_app);
      root2.render(<StrictMode>{render_component}</StrictMode>);
      break;
  }

  if (render_comp != '' && div_app != '') {
    const root = createRoot(div_app);
    root.render(<StrictMode>{render_comp}</StrictMode>);
    // render(render_comp, div_app);
  }

}

//For widgets

const widget_search = document.getElementById('wpvc-root-widget');

if (widget_search != null) {
  let div_getwidget = document.querySelectorAll("[id^='wpvc-photoleader-page-']");
  if (div_getwidget.length > 0) {
    div_getwidget.forEach(function (item, index) {

      const widget_div_app = document.getElementById(item.id);
      const widget_siteurl = widget_div_app.getAttribute('data-url');
      setTranslation(widget_siteurl);
      const widget_get_store = createStore(frontreducer, applyMiddleware(thunk));
      const widget_shortarg = JSON.parse(widget_div_app.getAttribute('data-args'));
      let widget_render_comp = <ThemeProvider theme={votingtheme}><Provider store={widget_get_store}><I18nextProvider i18n={i18n}><Leaderwidgets widget={'leader'} shortagrument={widget_shortarg} CONSTANT={Constants} SITE_URL={widget_siteurl} /></I18nextProvider></Provider></ThemeProvider>;
      // render(widget_render_comp, widget_div_app);
      const root = createRoot(widget_div_app);
      root.render(<StrictMode>{widget_render_comp}</StrictMode>);
      return;
    });
  }
}

const widget_recent = document.getElementById('wpvc-root-widget-recent');
if (widget_recent != null) {

  let div_recengetwidget = document.querySelectorAll("[id^='wpvc-recent-contestants-page-']");
  if (div_recengetwidget.length > 0) {
    div_recengetwidget.forEach(function (item, index) {

      const recent_widget_div_app = document.getElementById(item.id);
      const recent_widget_siteurl = recent_widget_div_app.getAttribute('data-url');
      setTranslation(recent_widget_siteurl);
      const recent_widget_get_store = createStore(frontreducer, applyMiddleware(thunk));
      const recent_widget_shortarg = JSON.parse(recent_widget_div_app.getAttribute('data-args'));
      const recent_widget_render_comp = <ThemeProvider theme={votingtheme}><Provider store={recent_widget_get_store}><I18nextProvider i18n={i18n}><Leaderwidgets widget={'recent'} shortagrument={recent_widget_shortarg} CONSTANT={Constants} SITE_URL={recent_widget_siteurl} /></I18nextProvider></Provider></ThemeProvider>;
      // render(recent_widget_render_comp, recent_widget_div_app);
      const root = createRoot(recent_widget_div_app);
      root.render(<StrictMode>{recent_widget_render_comp}</StrictMode>);
      return;
    });
  }
}

setTimeout(console.log.bind(console, '%cWP VOTING CONTEST', 'color: #303f9f;font-weight:bold;font-size:30px'), 0);

function setTranslation(siteurl) {

  //Get Translation data
  const HASH = Cookies.get('wpvc_voting_authorize');
  let dataURL = siteurl + "wpvc-voting/v1/wpvcgetsitetranslations";

  const requestOptions = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json', 'Authorize-wpvc': HASH, 'Authorize-wpvc-request': 'xmlhttprequest' }
  };

  fetch(dataURL, requestOptions)
    .then(res => res.json())
    .then(
      (result) => {

        //After Data Loading Send to Get Data to display the data respectively
        i18n.addResources(result.site_translations.language, "translations", result.site_translations.translations);
        i18n.changeLanguage(result.site_translations.language, (err, t) => {
          if (err) return console.log('something went wrong loading', err);
        });
      },
      (error) => {
        console.log('something went wrong loading', error);
      }
    );
}